import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the Transfers container.
 * Consolidates 11 individual useSelector calls into one, reducing re-renders.
 * Includes derived isDataTableLoading boolean to avoid repeating the OR logic.
 */
export const selectTransfersPageContext = createSelector(
  [
    (state: RootState) => state.accountsStore,
    (state: RootState) => state.cardsStore,
    (state: RootState) => state.userStore,
  ],
  (accountsStore, cardsStore, userStore) => ({
    allAccounts: accountsStore.allAccounts,
    pendingTransferCards: cardsStore.pendingCards,
    pendingTransferCardsSize: cardsStore.pendingCardsSize,
    errors: cardsStore.pendingCardsError,
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    assignedAccountNumber: userStore.assignedAccountNumber,
    cancelPendingTransferBatchLoaded: cardsStore.cancelPendingTransferBatchLoaded,
    updatePendingTransferBatchLoaded: cardsStore.updatePendingTransferBatchLoaded,
    canReadWrite: userStore.canReadWriteCards,
    isDataTableLoading:
      cardsStore.pendingCardsLoading ||
      cardsStore.cancelPendingTransferBatchLoading ||
      cardsStore.updatePendingTransferBatchLoading,
    loggedInUser: userStore.loggedInUser,
  })
);
